import { isAnyOf } from '@reduxjs/toolkit';

import {
  getCaptionStartSource,
  isUnchangedVoiceSessionUpdate,
  startCaptionsSessionIfReady,
} from '../helpers/captionSession';
import type { AppStartListening } from '../helpers/types';

import { connectCall } from 'features/call/call-ui-state/store';
import {
  setVoiceSession,
  setVoiceSessionId,
} from 'features/voice-session/store';

// What starts captions: the call connects, or a new voice session id arrives.
// User toggles start through toggleCaptionsThunk, not a listener here.
export const registerCaptionSessionListeners = (
  startListening: AppStartListening
) => {
  startListening({
    matcher: isAnyOf(connectCall, setVoiceSessionId, setVoiceSession),
    effect: async (action, api) => {
      if (isUnchangedVoiceSessionUpdate(action, api)) {
        return;
      }

      await startCaptionsSessionIfReady(api, getCaptionStartSource(action));
    },
  });
};
